import "core-js/modules/web.timers.js";
// Duplicated from ab-common
// reference: https://davidwalsh.name/javascript-debounce-function
var debounce = function debounce(func, wait, immediate) {
  var timeout;
  return function debouncedFunc() {
    var context = this; // eslint-disable-line @typescript-eslint/no-this-alias
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};
export default debounce;